// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `dialog {
  width: 550px;
}

.KXIa24 {
  display: none;
  margin-left: auto;
}

.boNBgE {
  font-size: var(--font-size-md, 14px);
  font-weight: var(--font-weight-regular, 400);
  margin-bottom: var(--spacing-3, 24px);
}

.Y8yFwE {
  display: flex;
  gap: var(--spacing-2, 12px);
  justify-content: space-between;

  button {
    flex-grow: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/contabilidade-digital/src/pages/ContabilidadeDigitalDasboard/components/UnlinkAccountModal/UnlinkAccountModal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,4CAA4C;EAC5C,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,8BAA8B;;EAE9B;IACE,YAAY;EACd;AACF","sourcesContent":["dialog {\n  width: 550px;\n}\n\n.closeButton {\n  display: none;\n  margin-left: auto;\n}\n\n.text {\n  font-size: var(--font-size-md, 14px);\n  font-weight: var(--font-weight-regular, 400);\n  margin-bottom: var(--spacing-3, 24px);\n}\n\n.buttons {\n  display: flex;\n  gap: var(--spacing-2, 12px);\n  justify-content: space-between;\n\n  button {\n    flex-grow: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"closeButton": `KXIa24`,
	"text": `boNBgE`,
	"buttons": `Y8yFwE`
};
module.exports = ___CSS_LOADER_EXPORT___;
